module.exports = __webpack_public_path__ + "img/ai_base.b73c70be.png";